import * as React from 'react';
import FileField, { IFileField } from '@adecco/base-app/src/components/atoms/FileField/FileField';

const FileUpload: React.FunctionComponent<IFileField> = ({ ...props }) => <FileField {...props} />;

export default FileUpload;
